import React from "react";

// Grievance status definitions
export const GRIEVANCE_STATUS = {
  RAISED: "1", // Grievance Raised By ESM
  ACCEPTED: "2", // Grievance Accepted By Aresa Center & Forwarded
  REJECTED: "3", // Grievance Rejected By Aresa Center
  IN_PROGRESS: "4", // In Progress at Branch
  AWAITING_DOCUMENTS: "5", // Awaiting Documents from ESM
  DOCUMENT_RESUBMITTED: "6", // Document Resubmitted by ESM
  COMPLETED: "7", // Completed
  CLOSED: "8", // Feedback submitted By ESM & Closed
  REOPENED: "9", // Re-opened by ESM
};

// Get status name from status ID
export const getStatusName = (statusId) => {
  console.log(statusId)
  switch (statusId) {
    case "1":
      return "Grievance Raised By ESM";
    case "2":
      return "Change Of Grevience Category";
    case "3":
      return "Grievance Rejected";
    case "4":
      return "In Progress";
    case "5":
      return "Awaiting Documents from ESM";
    case "6":
      return "Document Resubmitted by ESM";
    case "7":
      return "Completed";
    case "8":
      return "Feedback submitted By ESM & Closed";
    case "9":
      return "Re-opened by ESM";
      case 18:
        return "Escalated to Next Level";
    default:
      return "UnKnown";
  }
};

// Get allowed actions per role
export const getAllowedActions = (userRole, currentStatusId) => {
  // Role 2: ARESA Center
  // if (userRole === 2) {
  //   // Only show actions if grievance is in RAISED or REOPENED status
  //   if (
  //     currentStatusId == GRIEVANCE_STATUS.RAISED ||
  //     currentStatusId == GRIEVANCE_STATUS.REOPENED
  //   ) {
  //     return [
  //       {
  //         id: GRIEVANCE_STATUS.ACCEPTED,
  //         label: "Accept & Forward",
  //         icon: "bi-check-circle",
  //         buttonClass: "branch-button-success",
  //         description: "Accept this grievance and forward to Branch",
  //       },
  //       {
  //         id: GRIEVANCE_STATUS.REJECTED,
  //         label: "Reject",
  //         icon: "bi-x-circle",
  //         buttonClass: "branch-button-danger",
  //         description: "Reject this grievance if not valid",
  //       },
  //     ];
  //   }
  //   return []; // No actions allowed for other statuses
  // }

  // Role 3: Branch User
  if (userRole === 3  || userRole === 9 ) {
    // Only show actions if grievance is in ACCEPTED or DOCUMENT_RESUBMITTED status
    if (
      currentStatusId === GRIEVANCE_STATUS.ACCEPTED ||
      currentStatusId === GRIEVANCE_STATUS.DOCUMENT_RESUBMITTED || 
      currentStatusId == GRIEVANCE_STATUS.RAISED ||
          currentStatusId == GRIEVANCE_STATUS.REOPENED
    ) {
      return [
       
                //         },
        {
          id: GRIEVANCE_STATUS.IN_PROGRESS,
          label: "Mark In Progress",
          icon: "bi-arrow-repeat",
          buttonClass: "branch-button-primary",
          description: "Mark this grievance as in progress",
        },
        {
          id: GRIEVANCE_STATUS.AWAITING_DOCUMENTS,
          label: "Request Documents",
          icon: "bi-hourglass-split",
          buttonClass: "branch-button-warning",
          description: "Request additional documents from ESM",
        },
        {
          id: GRIEVANCE_STATUS.COMPLETED,
          label: "Mark as Completed",
          icon: "bi-check-circle",
          buttonClass: "branch-button-success",
          description: "Mark this grievance as completed",
        },
      ];
    }
    // If already in progress, they can still request documents or mark as completed
    else if (currentStatusId === GRIEVANCE_STATUS.IN_PROGRESS) {
      return [
        {
          id: GRIEVANCE_STATUS.IN_PROGRESS,
          label: "Mark In Progress",
          icon: "bi-arrow-repeat",
          buttonClass: "branch-button-primary",
          description: "Mark this grievance as in progress",
        },
        {
          id: GRIEVANCE_STATUS.AWAITING_DOCUMENTS,
          label: "Request Documents",
          icon: "bi-hourglass-split",
          buttonClass: "branch-button-warning",
          description: "Request additional documents from ESM",
        },
        {
          id: GRIEVANCE_STATUS.COMPLETED,
          label: "Mark as Completed",
          icon: "bi-check-circle",
          buttonClass: "branch-button-success",
          description: "Mark this grievance as completed",
        },
      ];
    }
    return []; // No actions allowed for other statuses
  }

  // Role 4 & 5: DGAR and COLA - View only, no actions
  else if (
    userRole === 4 ||
    userRole === 5 ||
    userRole === 6 ||
    userRole === 7 ||
    userRole === 8
  ) {
    return [];
  }

  return [];
};

// Check if status can be updated by the current user
export const canUpdateStatus = (userRole, currentStatusId) => {
  // Role 2: ARESA Center
  // if (userRole === 2) {
  //   return (
  //     currentStatusId === GRIEVANCE_STATUS.RAISED ||
  //     currentStatusId === GRIEVANCE_STATUS.REOPENED
  //   );
  // }

  // Role 3: Branch User
  if (userRole === 3) {
    return (
      currentStatusId === GRIEVANCE_STATUS.ACCEPTED ||
      currentStatusId === GRIEVANCE_STATUS.IN_PROGRESS ||
      currentStatusId === GRIEVANCE_STATUS.DOCUMENT_RESUBMITTED ||
      currentStatusId === GRIEVANCE_STATUS.RAISED ||
      currentStatusId === GRIEVANCE_STATUS.REOPENED
    );
  }
  if (userRole === 9) {
    return (
      currentStatusId === GRIEVANCE_STATUS.ACCEPTED ||
      currentStatusId === GRIEVANCE_STATUS.IN_PROGRESS ||
      currentStatusId === GRIEVANCE_STATUS.DOCUMENT_RESUBMITTED ||
      currentStatusId === GRIEVANCE_STATUS.RAISED ||
      currentStatusId === GRIEVANCE_STATUS.REOPENED
    );
  }


  //  View only
  return false;
};

// Check if documents can be uploaded by the current user
export const canUploadDocuments = (userRole) => {
  // Only Branch users can upload documents
  return userRole === 3 ||  userRole === 9 ;
};

// Get appropriate message for the current status
export const getStatusMessage = (currentStatusId, rating) => {
  switch (currentStatusId) {
    case GRIEVANCE_STATUS.COMPLETED:
      return {
        title: "This grievance has been marked as completed",
        description: "The grievance is awaiting feedback from the ESM",
        type: "success",
      };
    case GRIEVANCE_STATUS.REJECTED:
      return {
        title: "This grievance has been rejected",
        description: "This grievance cannot be processed further.",
        type: "error",
      };
    case GRIEVANCE_STATUS.CLOSED:
      return {
        title: "This grievance has been closed with user feedback",
        description: `User has provided a rating of ${rating || 0}/5`,
        type: "success",
      };
    case GRIEVANCE_STATUS.AWAITING_DOCUMENTS:
      return {
        title: "Awaiting documents from ESM",
        description: "Branch has requested additional documents",
        type: "info",
      };
    default:
      return {
        title: `Current status: ${getStatusName(currentStatusId)}`,
        description: "Please check the timeline for more details.",
        type: "info",
      };
  }
};

export default {
  GRIEVANCE_STATUS,
  getStatusName,
  getAllowedActions,
  canUpdateStatus,
  canUploadDocuments,
  getStatusMessage,
};
